import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faPlus,
  faMinus
} from "@fortawesome/free-solid-svg-icons";
import { faSquare } from "@fortawesome/free-regular-svg-icons";
import { StoreContext } from "components/StoreContext";
import LinkButton from "components/LinkButton";

const Categories = props => {
  const { id } = props;
  const limitAfter = 4;
  const [isFilterCollapsed, setFilterCollapsed] = useState(false);
  const [isFilterLimited, setFilterLimited] = useState(true);
  const { categories } = useContext(StoreContext);

  useEffect(() => {
    setFilterLimited(true);
  }, []);

  const links = id !== 0 ? categories.list[id].children : categories.tree;

  if (links.length === 0) {
    return null;
  }

  return (
    <div
      className={`products__filter${isFilterCollapsed ? " is-collapsed" : ""}${
        isFilterLimited ? " is-limited" : ""
      }`}
    >
      <div className="products__filter-header">
        <p className="products__filter-name">Categories</p>
        <button
          type="button"
          className="products__filter-toggle"
          aria-label="Toggle Open"
          onClick={() => setFilterCollapsed(!isFilterCollapsed)}
        >
          <FontAwesomeIcon icon={faChevronDown} />
        </button>
      </div>
      <div className="products__filter-body">
        <ul className="products__filter-items">
          {links.map((link, index) => (
            <li
              key={link.id}
              className={index > limitAfter - 1 ? "is-more" : ""}
            >
              <LinkButton to={link.path}>
                <FontAwesomeIcon
                  icon={faSquare}
                  className="products__filter-icon"
                />
                <span className="products__filter-label">{link.text}</span>
                <span className="products__filter-count">{link.products}</span>
              </LinkButton>
            </li>
          ))}
        </ul>
        {links.length > limitAfter - 1 && links[4] !== undefined && (
          <button
            type="button"
            className="products__filter-more"
            aria-label="Toggle More and Less"
            onClick={() => setFilterLimited(!isFilterLimited)}
          >
            {isFilterLimited ? (
              <span>
                <FontAwesomeIcon icon={faPlus} size="sm" />
                <span>See More </span>
              </span>
            ) : (
              <span>
                <FontAwesomeIcon icon={faMinus} size="sm" />
                <span>See Fewer </span>
              </span>
            )}
          </button>
        )}
      </div>
    </div>
  );
};

Categories.propTypes = {
  id: PropTypes.number.isRequired
};

export default Categories;
